// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2sp4v","range":"MonthRangeSwitch_range__2Wjp4","disabled":"MonthRangeSwitch_disabled__n1ZN7"};